export default "__VITE_ASSET__D78gc$HF__"